// preLoaderAnimation.js
import Style from "./preLoaderAnimation.module.css"
export default function PreLoaderAnimation(props){
    return (
        <div className={Style.main}>
            <div className={Style.container}>
                {/* left section */}
                <div className={Style.left}>

                </div>
                {/* middle section */}
                <div className={Style.middle}>
                    <p>Loading 
                        <span className={Style.onlyDesk} style={{color:"#888",marginLeft:"20px"}}>Interface</span>
                    </p>
                </div>
                {/* right section */}
                <div className={Style.right}>
                    <p className={Style.designby}>designed and built by team</p>
                    <p  className={Style.bitBandits}>BitBandits</p>
                </div>
                
            </div>
            <div className={Style.disclaimer}> 
                    <p>this is a prototype, final iteration will be 70% similar</p>
            </div>
            <div className={Style.teamInitials}>
                <p>BitBandits</p>
            </div>
        </div>
    )
}